import { defineAsyncComponent } from 'vue';
import { ModalOptions, ModalOptionWidth } from '@/core/modals/ModalState';
import { AbstractModalService } from '@/core/modals/AbstractModalService';
import { UserViewObject } from '@/types/apiServerContract';
import { BecomeACustomerInterestViewModel } from '@/types/contentServerContract';

export enum FormRequestType {
    'itemExport',
    'integrations',
    'punchout',
    'dropshipment',
    'directDebit'
}

interface FormRequestOverlayOptions {
    formType: FormRequestType;
    account?: UserViewObject;
    areaOfInterests?: BecomeACustomerInterestViewModel[];
    customerNo?: string;
    customerName?: string;
}

class FormRequestOverlayService extends AbstractModalService {
    public show(formOptions: FormRequestOverlayOptions, options?: Partial<ModalOptions>): Promise<void> {
        return this.showModal({
            component: defineAsyncComponent(() => import(
                '@/project/app/client-pages/my-account/forms/FormRequestOverlay.vue')),
            componentAttrs: {
                formType: formOptions.formType,
                account: formOptions.account,
                areaOfInterests: formOptions?.areaOfInterests,
                customerNo: formOptions?.customerNo,
                customerName: formOptions?.customerName,
            },
            options: {
                width: ModalOptionWidth.Normal,
                closeOnBreakpointChange: false,
                ...options
            }
        });
    }
}

export default new FormRequestOverlayService();
